import * as React from 'react';
import { Hi } from './Hi';

interface Props {
  header: string;
  subHeader?: string | React.ReactNode;
  className?: string;
}

export const Header: React.FC<Props> = (props) => {
  return (
    <div className={`text-center space-y-3 ${props.className || ''}`}>
      <Hi />
      <h1 className="font-bold">{props.header}</h1>
      <h4 className="text-gray-500">{props.subHeader}</h4>
    </div>
  );
};
